<template lang="pug">
div
  h1.title {{isMa ? 'Pesquisa de processo' : 'Pesquisa de relatórios'}}

  el-row(:gutter="10")

    el-col(:lg="6", :md="12", :sm="24")
      p.label Nome/Razão social do interessado:
      el-input.input(
        @keyup.native.enter="consultar"
        name="nomeInteressado",
        type="text",
        v-model="filtroSearch.nomeInteressado"
      )

    el-col(:lg="6", :md="12", :sm="24")
      p.label CPF/CNPJ do interessado:
      el-input(
        @keyup.native.enter="consultar"
        type="text",
        name="cpfInteressado",
        v-mask="['###.###.###-##', '##.###.###/####-##']",
        v-model="filtroSearch.cpfInteressado"
        )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Número do processo:
      el-input.input(
        @keyup.native.enter="consultar"
        name="numeroProcesso",
        type="text",
        v-model="filtroSearch.numeroProcesso"
      )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Número do comprovante:
      el-input.input(
        @keyup.native.enter="consultar"
        name="numeroComprovante",
        type="text",
        v-model="filtroSearch.numeroComprovante"
      )

  el-row(:gutter="10")

    el-col(:lg="6", :md="12", :sm="24")
      p.label Período de cadastro:
      el-date-picker.full-width.input.date(
        type="daterange",
        start-placeholder="Data inicial",
        end-placeholder="Data Final",
        format="dd/MM/yyyy",
        name='dataCadastro',
        v-model="dataCadastro",
      )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Tipo de processo:
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        default-first-option=false,
        name="tiposProcesso",
        v-model="filtroSearch.tiposProcesso",
      )
        el-option(
          v-for="item in getOrdered(tiposProcesso)",
          :key="item.id",
          :label="item.nome",
          :value="item.codigo",
        )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Município:
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        default-first-option=false,
        name="municipio",
        collapse-tags,
        v-model="filtroSearch.municipios",
      )
        el-option(
          v-for="item in municipios",
          :key="item.nome",
          :label="item.nome",
          :value="item.id",
        )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Situação do processo:
      el-select(
        v-if="isEstadoAP"
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        collapse-tags,
        default-first-option=false,
        name="situacoesProcesso",
        v-model="filtroSearch.situacoesProcesso",
      )
        el-option(
          class="inputSelect"
          v-for="item in listaStatusAmapa",
          :key="item.codigo",
          :label="item.nome",
          :value="item.codigo",
        )
      el-select(
        v-else
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        collapse-tags,
        default-first-option=false,
        name="situacoesProcesso",
        v-model="filtroSearch.situacoesProcesso",
      )
        el-option(
          class="inputSelect"
          v-for="item in getStatusFormatted(status)",
          :key="item.codigo",
          :label="item.nome",
          :value="item.codigo",
        )
  el-row(:gutter="10")

    el-col(:lg="6", :md="12", :sm="24")
      p.label Processos que estão no setor:
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        collapse-tags,
        default-first-option=false,
        name="processosSetor",
        v-model="filtroSearch.setoresAtuais",
        @input="handleChangeSetorAtual",
      )
        el-option(
          v-for="item in getSetorFormatted(setores)",
          :key="item.codigo",
          :label="formatLabelSetor(item)",
          :value="item.codigo",
        )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Técnicos responsáveis:
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        collapse-tags,
        default-first-option=false,
        name="responsaveisAtuais",
        v-model="filtroSearch.responsaveisAtuais",
        :disabled="filtroSearch.setoresAtuais && filtroSearch.setoresAtuais.length === 0",
      )
        el-option(
          v-for="item in getTecnicosFormatted(responsaveisAtuais)",
          :key="item.id",
          :label="item.nome",
          :value="item.id",
        )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Processos que passaram pelo setor:
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        collapse-tags,
        default-first-option=false,
        name="processosSetorPassado",
        v-model="filtroSearch.setoresPassados",
        @input="handleChangeSetorPassados",
      )
        el-option(
          v-for="item in getSetorFormatted(setores)",
          :key="item.codigo",
          :label="formatLabelSetor(item)",
          :value="item.codigo",
        )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Técnicos responsáveis passados:
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        collapse-tags,
        default-first-option=false,
        name="responsaveisPassados",
        v-model="filtroSearch.responsaveisPassados",
        :disabled="filtroSearch.setoresPassados && filtroSearch.setoresPassados.length === 0",
      )
        el-option(
          v-for="item in getTecnicosFormatted(responsaveisPassados)",
          :key="item.id",
          :label="item.nome",
          :value="item.id",
        )
  el-row(:gutter="10")
    el-col(:lg="6", :md="12", :sm="24" v-if="isEstadoPA  || isEstadoAP")
      p.label Interseção com camada de bloqueio
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        collapse-tags,
        default-first-option=false,
        name="statusBloqueioDinamico",
        v-model="filtroSearch.statusBloqueioDinamico",
      )
        el-option(
          v-for="item in statusBloqueioDinamico",
          :key="item.codigo",
          :label="item.descricao",
          :value="item.codigo",
        )
    el-col(:lg="6", :md="12", :sm="24" v-if="isEstadoPA")
      p.label Monitoramento ambiental
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        collapse-tags,
        default-first-option=false,
        name="statusAmbiental",
        v-model="filtroSearch.statusAmbiental",
      )
        el-option(
          v-for="item in statusAmbiental",
          :key="item.codigo",
          :label="item.descricao",
          :value="item.codigo",
        )
  el-row(:gutter="10")
    div.row
      span(@click="exibirBuscaPorLote")
        p.busca Pesquisa por lote
      el-tooltip(
        effect='dark',
        placement="top-end"
      )
        i.el-icon-info.icon-info
        template(slot="content") Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir.&nbsp
          a.btn-download(@click="baixarModelo") (Baixar modelo)
    div
      app-upload-area(
        v-if="showPesquisaLote",
        id="lote",
        :target="'publico/upload'"
        :fileType="validExtensions"
        :onSuccess="onSuccess"
        :documento="file"
        :hasDownloadButton="false",
        v-model="file"
        @removerDocumento="removerDocumento"
      )
  el-row.button-row
    span.limpar(@click="limpar") Limpar
    el-button(type="primary", @click="consultar")
      i.icon(class="fa fa-search")
      | Pesquisar

  h1 Resultado da pesquisa

  div
    app-listagem-processos-relatorio(
      :processos="processos.content",
      :totalItems.sync="processos.totalElements || 0",
      @changePage="changePage",
      @clicked="onClickedProcessoListagem",
      @changeOrder="changeOrder"
      :page-size="pageSize"
      :currentPage="page",
      :loading="loadingTable"
    )

  el-row.button-row
    el-button.right(
      type="default",
      size="small"
      :disabled="disableExportarCSV",
      @click="getCsv",
    )
      i.fal.fa-file-csv
      span &nbsp Exportar CSV

</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import EnumFormatter from '../../../../utils/EnumFormatter'
import AppListagemProcessosRelatorio from './AppListagemProcessosRelatorio.vue'
import AppUploadArea from '@/components/AppUploadArea'
import AppNotificacao from '@/components/mixins/AppNotificacao'
const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {

  components: {
    AppListagemProcessosRelatorio,
    AppUploadArea
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      page: 1,
      disableExportarCSV: true,
      isPara: process.env.ESTADO === 'pa',
      isMa: process.env.ESTADO === 'ma',
      isAp: process.env.ESTADO === 'ap',
      filtroSearch: {
        pagina: 0,
        nomeInteressado: null,
        cpfInteressado: null,
        dataInicio: [],
        dataFim: [],
        tiposProcesso: [],
        municipios: [],
        situacoesProcesso: [],
        setoresAtuais: [],
        setoresPassados: [],
        responsaveisAtuais: [],
        tipoPesquisa: 'SIMPLIFICADO',
        ordem: 'numeroProcesso',
        numeroProcesso: null,
        numeroComprovante: null,
        nomePlanilha: null,
        statusAmbiental: null,
        statusBloqueioDinamico: null
      },
      dataCadastro: [],
      tiposProcesso: [],
      municipios: [],
      status: [],
      listaStatusAmapa: [],
      statusFormatado: null,
      setores: [],
      clickedProcesso: {},
      responsaveisAtuais: [],
      responsaveisPassados: [],
      processos: [],
      statusAmbiental: [
        { codigo: 'STATUS1', descricao: 'Status-1 (Art. 73 - I)' },
        { codigo: 'STATUS2', descricao: 'Status-2 (Art. 73 - III)' },
        { codigo: 'STATUS3', descricao: 'Status-3 (Art. 73 - IV)' },
        { codigo: 'STATUS4', descricao: 'Status-4 (100% floresta até 2014)' },
        { codigo: 'STATUS5', descricao: 'Status-5 (Art. 73 - V)' },
        { codigo: 'STATUS6', descricao: 'Status-6 (Art. 73 - II)' }
      ],
      statusBloqueioDinamico: [
        { codigo: 'BLOQUEADO', descricao: 'Com interseção' },
        { codigo: 'NAO_BLOQUEADO', descricao: 'Sem interseção' },
        { codigo: 'NAO_ANALISADO', descricao: 'Não analisado' }
      ],
      file: null,
      showPesquisaLote: false,
      validExtensions: ['xlsx', 'xls', 'csv'],
      loadingTable: true
    }
  },

  async created () {
    if (this.isEstadoAP) {
      this.listaStatusAmapa = await this.getAllStatusProcesso()
      this.statusAmbiental = [
        { codigo: 'ALERTA', descricao: 'Alerta' }
      ]
    }
    const filterInfo = await this.getFilterInfo()

    this.tiposProcesso = filterInfo.tiposProcesso
    this.municipios = filterInfo.municipios
    this.setores = filterInfo.setores
    this.status = filterInfo.status
    this.statusFormatado = filterInfo.statusFormatado
    await this.consultar()

    this.disableExportarCSV = this.processo > 0
  },

  props: {
    pageSize: {
      type: Number,
      default: 15
    },
    loading: {
      Type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions({
      getCountProcessos: 'dashboardRelatorios/getCountProcessos',
      findProcessosByFilter: 'dashboardRelatorios/findProcessosByFilter',
      getCsvDashboardRelatorios: 'dashboardRelatorios/getCsvDashboardRelatorios',
      getCsvDashboardRelatoriosAp: 'dashboardRelatorios/getCsvDashboardRelatoriosAp',
      getFilterInfo: 'dashboardRelatorios/getFilterInfo',
      getTecnicosResponsaveis: 'dashboardRelatorios/getTecnicosResponsaveis',
      getModeloRelatorio: 'dashboardRelatorios/downloadModelo',
      getSetoresInformacoesPendentes: 'informacao/getSetoresInformacoesPendentes',
      getAllStatusProcesso: 'dashboardRelatorios/getAllStatusProcessos'
    }),
    getStatusFormatted (control) {
      return _.orderBy(control)
        .filter(status => this.statusFormatado[status])
        .map((status1) => ({ nome: this.statusFormatado[status1], codigo: status1 }))
    },
    getSetorFormatted (setor) {
      const setores = setor.filter(setor => (setor.codigo !== 'AGENDAMENTO') && (setor.codigo !== 'PARAMETRIZACAO'))
      const selectFormatted = _.orderBy(setores, ['codigo'], ['asc'])
      return selectFormatted
    },
    getOrdered (control) {
      const selectFormatted = _.orderBy(control)
      return selectFormatted
    },
    getTecnicosFormatted (tecnicos) {
      const tecnicosFormmatted = tecnicos ?  tecnicos.map((tec) => { // eslint-disable-line
        return {
          nome: tec?.pessoa?.pessoaFisica?.nome?.toUpperCase(),
          id: tec.id
        }
      }) : []

      const selectFormatted = _.orderBy(tecnicosFormmatted, ['nome'], ['asc'])
      return selectFormatted
    },
    getTipoFormatado (codigo) {
      return EnumFormatter.getTipoFormatado(codigo)
    },
    async consultar () {
      this.loadingTable = true
      this.filtroSearch.simplificado = false
      this.filtroSearch.pagina = 0
      this.page = 1

      if (this.dataCadastro && this.dataCadastro.length > 1) {
        this.filtroSearch.dataInicio = this.dataCadastro[0]
        this.filtroSearch.dataFim = this.dataCadastro[1]
      } else {
        this.filtroSearch.dataInicio = null
        this.filtroSearch.dataFim = null
      }
      let tiposProcesso = this.tiposProcessosAjustado()
      this.processos = await this.findProcessosByFilter({...this.filtroSearch, tiposProcesso})

      if (this.isAp) {
        await this.virificaSetoresInformacoesPendentes()
      }
      this.loadingTable = false
    },

    tiposProcessosAjustado () {
      let tiposProcesso = this.filtroSearch.tiposProcesso ? [...this.filtroSearch.tiposProcesso] : []
      if (this.isMa) {
        if (tiposProcesso.includes('NAO_ONEROSO')) {
          tiposProcesso.push('NAO_ONEROSO_FISICO')
        }
        if (tiposProcesso.includes('ONEROSO')) {
          tiposProcesso.push('ONEROSO_FISICO')
        }
      }
      return tiposProcesso
    },

    exibirBuscaPorLote () {
      this.showPesquisaLote = !this.showPesquisaLote
    },

    async changePage (newPage) {
      this.page = newPage
      this.filtroSearch.pagina = newPage - 1

      this.loadingTable = true
      let tiposProcesso = this.tiposProcessosAjustado()
      this.processos = await this.findProcessosByFilter({...this.filtroSearch, tiposProcesso})
      this.loadingTable = false
      if (this.isAp) {
        await this.virificaSetoresInformacoesPendentes()
      }
    },

    async limpar () {
      this.filtroSearch = {
        pagina: 0,
        nomeInteressado: null,
        cpfInteressado: null,
        dataInicio: [],
        statusBloqueioDinamico: null,
        statusAmbiental: null,
        dataFim: [],
        tiposProcesso: [],
        municipios: [],
        situacoesProcesso: [],
        setoresAtuais: [],
        setoresPassados: [],
        responsaveisAtuais: [],
        responsaveisPassados: [],
        tipoPesquisa: 'SIMPLIFICADO',
        numeroProcesso: null,
        numeroComprovante: null,
        nomePlanilha: null
      }

      this.file = null

      this.page = 1
      this.dataCadastro = []
      this.loadingTable = true

      this.processos = await this.findProcessosByFilter(this.filtroSearch)

      if (this.isAp) {
        await this.virificaSetoresInformacoesPendentes()
      }

      this.loadingTable = false
    },
    async handleChangeSetorPassados () {
      this.filtroSearch.responsaveisPassados = null
      if (this.filtroSearch.setoresPassados && this.filtroSearch.setoresPassados.length > 0) {
        this.responsaveisPassados = await this.getTecnicosResponsaveis(this.filtroSearch.setoresPassados)
      }
    },
    async handleChangeSetorAtual () {
      this.filtroSearch.responsaveisAtuais = null
      if (this.filtroSearch.setoresAtuais && this.filtroSearch.setoresAtuais.length > 0) {
        this.responsaveisAtuais = await this.getTecnicosResponsaveis(this.filtroSearch.setoresAtuais)
      }
    },

    /*
     * Função que envia o processo, que veio do componente filho AppListagemProcessosRelatorios,
     * para a tela de relatorios, para ser exibido no modal
     */
    onClickedProcessoListagem (processo) {
      this.$emit('viewProcessosHasClicked', processo)
    },

    // Exporta csv com os dados buscado de acordo com o filtro escolhido
    async getCsv () {
      if (process.env.ESTADO === 'ap') {
        await this.getCsvDashboardRelatoriosAp(this.filtroSearch).then(res => {
          if (!res.size > 0) {
            this.$alert(`O CSV está sendo gerado e dentro de alguns minutos será enviado para seu e-mail
              uma mensagem com o anexo.`, 'Sucesso', {
              confirmButtonText: 'Ok',
              type: 'success'
            })
          }
        })
      } else {
        let tiposProcesso = this.tiposProcessosAjustado()
        await this.getCsvDashboardRelatorios({...this.filtroSearch, tiposProcesso}).then(res => {
          if (!res.size > 0) {
            this.$alert(`O CSV está sendo gerado e dentro de alguns minutos será enviado para seu e-mail
              uma mensagem com o anexo.`, 'Sucesso', {
              confirmButtonText: 'Ok',
              type: 'success'
            })
          }
        })
      }
    },
    changeOrder (ordem) {
      this.changePage(1)

      if (ordem && ordem.column && ordem.prop) {
        if (ordem.prop === 'localizacoes') {
          this.filtroSearch.ordem = undefined
        } else if (ordem.prop === 'tipo.nome') {
          this.filtroSearch.ordem = 'tipo'
        } else {
          this.filtroSearch.ordem = ordem.prop
        }
        this.filtroSearch.ordemDirecao = ordem.order === 'ascending' ? 'ASC' : 'DESC'
      } else {
        this.filtroSearch.ordem = 'numeroProcesso'
        this.filtroSearch.ordemDirecao = 'DESC'
      }

      this.consultar()
    },
    formatLabelSetor (item) {
      if (item.codigo === 'TECNICO_DE_CAMPO') {
        return 'Técnico de campo'
      }

      if (item.setor === 'GP' && item.status.includes('ASSINATURA')) {
        return 'GP - Assinatura'
      }

      if (item.codigo.includes('ASSINATURA')) {
        return item.nome
      }

      return setoresFormatado[item.codigo]
    },
    onSuccess (id, resumableFile, fileKey) {
      this.file = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
      this.filtroSearch.nomePlanilha = this.file.fileKey
    },

    removerDocumento () {
      this.file = null
      this.filtroSearch.nomePlanilha = null
    },

    baixarModelo () {
      this.getModeloRelatorio()
    },

    getStatusBySetoresInformacoesPendentes (solicitacoes) {
      if (!solicitacoes || solicitacoes?.length === 0) {
        return null
      }
      const status = 'Aguardando informação'
      if (solicitacoes?.length === 1) {
        return `${status} do setor ${solicitacoes[0]?.setorRequerido}`
      }
      const setoresList = [...new Set(
        solicitacoes
          ?.map(s => s?.setorRequerido)
          ?.filter(s => s)
      )]
      const ultimoIndex = setoresList?.length - 1
      const setores = setoresList?.reduce((acumulate, current, index) => {
        if (index === 0) {
          return `${acumulate} ${current}`
        }
        if (index === ultimoIndex) {
          return `${acumulate} e ${current}`
        }
        return `${acumulate}, ${current}`
      }, 'dos setores')
      return `${status} ${setores}`
    },
    async virificaSetoresInformacoesPendentes () {
      const numerosProcessos = this.processos.content.map(data => data.numeroProcesso)
      const promises = numerosProcessos.map(numero => this.getSetoresInformacoesPendentes(numero))
      const results = await Promise.allSettled(promises)
      numerosProcessos.forEach((numero, indice) => {
        results[indice]['numeroProcesso'] = numero
      })
      this.processos.content.forEach(data => {
        const resultProcesso = results?.find(result => result?.numeroProcesso === data?.numeroProcesso)
        if (resultProcesso && resultProcesso?.status === 'fulfilled') {
          const novoStatus = this.getStatusBySetoresInformacoesPendentes(resultProcesso?.value)
          if (novoStatus) {
            data.statusFormatado = novoStatus
          }
        }
      })
    }
  },

  watch: {
    countProcessos (value) {
      this.disableExportarCSV = !(value > 0)
    },
    'filtroSearch.statusAmbiental' (value) {
      if (value === '') {
        this.filtroSearch.statusAmbiental = null
      }
    },
    'filtroSearch.statusBloqueioDinamico' (value) {
      if (value === '') {
        this.filtroSearch.statusBloqueioDinamico = null
      }
    }
  },

  computed: {
    isEstadoPA () {
      return process.env.ESTADO === 'pa'
    },
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    }
  }
}

</script>

<style scoped lang="scss">
@import '../../../../assets/styles/element-variables.scss';
@import '@/assets/styles/element-variables.scss';

.limpar {
  margin-right: 20px;
  color: $--color-primary;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
.icon {
  margin-right: 7px;
}
.el-select {
  width: 100%;
}
.label {
  margin: 0;
  padding: 12px 0 8px 0px;
}
.button-row {
  margin-top: 10px;
  text-align: right;
}
.right {
  float: right;
  cursor: pointer;
  margin: 10px 0px;
}
.pagination {
    text-align: center;
}
.full-width {
    width: -webkit-fill-available;
}

/* Cards e gráficos */
.cardTotais:nth-child(-n + 2) {
  margin-bottom: 5%;
}

.cardTotais {
  width: 45%;
  margin-right: 20px;
}

.card-graficos {
  border: 2px solid #34495e;
  border-radius: 12px;
  padding: 5px;
  box-shadow: 0px 3px 6px #00000029;
  text-align: center;
}

.dashboard-info{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.dashboard-info-cards {
  width: 50%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 0 5% 0;
  justify-content: space-between;
}

.busca {
  padding: 12px 0 8px 0px;
  text-align: left;
  color: $--color-primary !important;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}

.dashboard-info-graficos {
  width: 50%;
  padding: 0 0 5% 0;
}

.el-radio-group /deep/ .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

@media only screen and (max-width: 1256px) {
  .dashboard-info {
    flex-direction: column;
  }

  .dashboard-info-cards {
    width: auto;
    padding-right: 0;
  }

  .dashboard-info-graficos {
    width: auto;
  }

  .cardTotais {
    width: 46%;
  }

  .card-graficos {
    margin: 0;
  }

  .cardTotais:nth-child(2n) {
    margin-right: 0;
  }

}

.btn-download {
  text-decoration: underline;
  cursor: pointer;
  color: #f1f1f1;
}

.icon-info {
  font-size: 25;
  margin: 0 0 10px 5px;
}

@media only screen and (max-width: 456px){
  .inputSelect {
    left: 80px;
  }
}

</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/gerais/AppListagemRelatorio.vue